import React, { useState, useRef, useEffect } from 'react';
import Tabs from '../../../../Components/Tabs';
import editIcon from '../../../../Assets/Icons/edit.png';
import deleteIcon from '../../../../Assets/Icons/delete.png';
import forwordIcon from '../../../../Assets/Icons/forward.png'
import AddTaskCategoryModal from '../../../../Components/Modals/AddTaskCategoryModal';
import Input from '../../../../Components/Input';
import filterIcon from '../../../../Assets/Icons/filter.png'
import leftBtuIcon from '../../../../Assets/Icons/back.png'
import AddUserModal from '../../../../Components/AddUserModal';
import leftArrowIcon from '../../../../Assets/Icons/chevron-down.png';
import { useNavigate } from "react-router-dom";
import InvoiceBillController from '../../../Controllers/AdminScreens/Invoices/InvoiceBillController';
import TextInput from '../../../../Components/TextInput';
import DateInput from '../../../../Components/DateInput';
import search from '../../../../Assets/Icons/search.png';
import Dropdown from '../../../../Components/Dropdown';
import Loader from '../../../../Components/Loader';
import { convertGMTToLocal } from '../../../../Utils/Validation';
import printIcon from '../../../../Assets/Icons/Printer.png';
import DeleteConfirmationModal from '../../../../Components/Modals/DeleteConformationModal';

const InvoiceBillScreen = ({ invoiceList, loading, error, onRefresh }) => {

  const {
    handlePageChange,
    currentTasks,
    totalPages,
    currentPage,
    filterData,
    handleInputChange,
    handleSearchClient,
    searchLoading,
    searchError,
    clientList,
    searchUser,
    handleSearchInputText,
    handleSelectClient,
    servicesLoading,
    serviceOptions,
    servicesError,
    serviceListError,
    serviceListLoading,
    applyFilters,
    cancelFilters,
    resetFilters,
    filterError,
    recipientOptions,
    userLoading,
    userError,
    showFilters,
    toggleFilters,
    visiblePages,
    printInvoiceLoading,
    currentDocIndex,
    printInvoiceDocument, successMesg,
    printInvoiceError, isDeleteModalOpen, handleCloseDeleteModal,
    handleDeleteInvoiceFile, invoiceInfoRef, confirmDeleteInvoice, deleteLoading
  } = InvoiceBillController(invoiceList, onRefresh);

  const [userPermissions, setUserPermissions] = useState(null);
  useEffect(() => {
    const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
    setUserPermissions(storedUserInfo?.user_permissions || {});
  }, [])

  const navigate = useNavigate();
  const handleGenerateInvoive = () => {
    navigate("/generate-invoice");
  };
  const handleRecurringInvoive = () => {
    navigate("/recurring-invoice");
  };
  const handleEdit = (rowData) => {
    if (userPermissions?.invoices?.per_name_sub_json?.invoice_edit === 1) {
      navigate("/generate-invoice", {
        state: { rowData: rowData },
      });
    }
  };


  const [openDropdown, setOpenDropdown] = useState(null); // Tracks the currently open dropdown
  const toggleDropdown = (dropdownName) => {
    setOpenDropdown((prev) => (prev === dropdownName ? null : dropdownName));
  };

  const dropdownRefs = useRef({}); // Ref for dropdown

  // Handle clicks outside dropdowns
  useEffect(() => {
    const handleClickOutside = (event) => {
      const isOutside = Object.keys(dropdownRefs.current).every(
        (key) => dropdownRefs.current[key] && !dropdownRefs.current[key].contains(event.target)
      );
      if (isOutside) {
        setOpenDropdown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // console.log('invoice list:-',currentTasks)

  return (
    <>
      <div className='basic-info-container'>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <h3 style={styles.categoryHeader}>Invoices</h3>
          <div style={{ display: 'flex', justifyContent: 'center', gap: 10, alignItems: 'center' }}>
            {/* <div>
              {userPermissions?.invoices?.per_name_sub_json?.invoice_create === 1 &&
                <button className="add-client-button" style={{ paddingLeft: 30, paddingRight: 30 }} onClick={handleRecurringInvoive}>
                  Generate Recurring Invoices
                </button>
              }
            </div> */}
            <div>
              {userPermissions?.invoices?.per_name_sub_json?.invoice_create === 1 &&
                <button className="add-client-button" style={{ paddingLeft: 30, paddingRight: 30 }} onClick={handleGenerateInvoive}>
                  Generate Invoices
                </button>
              }
            </div>

          </div>
        </div>
        <div style={styles.container}>
          <div style={styles.filtersHeader}>
            <button style={styles.filterButton} onClick={toggleFilters}> <img src={filterIcon} style={styles.filterIcon} /> Filters</button>
            <div >
              <img src={leftBtuIcon} style={{ marginRight: '5px', cursor: 'pointer', width: '28px', height: '28px' }} />
              <img src={leftBtuIcon} style={{ transform: 'rotate(180deg)', transition: 'transform 0.3s ease', cursor: 'pointer', width: '28px', height: '28px' }} />
            </div>
          </div>
        </div>
        {/* Filters using Flexbox */}
        {showFilters && (
          <div className={`tasksScreen-filters-container ${showFilters ? 'tasksScreen-open-filters' : ''}`}>
            <div className="tasksScreen-filters">
              {/* Client Name Input */}
              <div className="filter-field">
                <label>Client Name</label>

                <TextInput
                  type="text"
                  placeholder="Client Name"
                  value={searchUser}
                  onChange={(e) => handleSearchInputText(e.target.value)}
                  onRightClick={handleSearchClient}
                  right={
                    searchLoading ? (
                      <Loader loading={searchLoading} color={'var(--primary-loader-color)'} size='small' /> // Show loader when loading
                    ) : (
                      <img src={search} alt="Search" style={{ cursor: 'pointer', height: '20px', width: '20px' }} />
                    )
                  }
                  style={{ padding: '20px 10px' }}
                  errorMessage={searchError}
                />
                {clientList.length > 0 && (
                  <ul style={styles.dropdownList}>
                    {clientList.map((client, index) => (
                      <li
                        key={client?.client_id}
                        onClick={() => handleSelectClient(client)}
                        style={{
                          ...styles.dropdownItem,
                          borderBottom: index !== clientList.length - 1 ? '1px solid #ccc' : 'none', // Add line below except last item
                        }}
                      >
                        {client?.client_name}
                      </li>
                    ))}
                  </ul>
                )}
              </div>

              <Dropdown
                ref={(el) => (dropdownRefs.current["Services"] = el)}
                isOpen={openDropdown === "Services"}
                toggleDropdown={() => toggleDropdown("Services")}
                label="Services"
                options={serviceOptions || []}
                value={filterData?.services}
                onChange={(value) => handleInputChange('services', value)}
                loading={servicesLoading}
                errorMessage={servicesError}
              />

              {/* Generated Date Range */}
              <div >
                <label style={{ fontSize: '12px', color: '#343C44' }}>Generated Date</label>
                <DateInput
                  label="Generated Date"
                  value={filterData.generatedDate || ""}
                  onChange={(e) => handleInputChange("generatedDate", e.target.value)}
                // minWidth={140}
                // errorMessage={noticeBoardPublishedDateError}
                // max={new Date().toISOString().split("T")[0]}
                />
              </div>

              <Dropdown
                ref={(el) => (dropdownRefs.current["Generated By"] = el)}
                isOpen={openDropdown === "Generated By"}
                toggleDropdown={() => toggleDropdown("Generated By")}
                label="Generated By"
                options={recipientOptions || []}
                placeholder="------"
                value={filterData?.generatedBy}
                onChange={(value) => handleInputChange('generatedBy', value)}
                loading={userLoading}
                errorMessage={userError}
              />

            </div>
            <div>
              {filterError && <div className="list-error-msg" style={{ textAlign: 'left', paddingBottom: 5 }}> {filterError}</div>}

              {/* Filter Buttons */}
              <div className="tasksScreen-filter-buttons">
                <button
                  onClick={applyFilters}
                  className="tasksScreen-apply-button"
                  style={{ cursor: serviceListLoading ? 'not-allowed' : 'pointer', opacity: serviceListLoading ? 0.5 : 1 }} disabled={serviceListLoading}
                >
                  Apply
                </button>
                <button
                  onClick={cancelFilters}
                  className="tasksScreen-cancel-button"
                >
                  Cancel
                </button>
                <button
                  onClick={resetFilters}
                  className="tasksScreen-reset-button"
                >
                  Reset
                </button>
              </div>
            </div>
          </div>
        )}
      </div>

      <div className='basic-info-card' style={{ border: 'none', padding: '0px' }}>
        <div style={styles.tableWrapper}>
          <table className="tasksScreen-task-table">
            <thead>
              <tr>
                <th style={{ width: "10%" }}>Invoice No.</th>
                {/* <th style={{ width: "20%" }}>Invoice Type</th> */}
                <th style={{ width: "15%" }}>Client Name</th>
                {/* <th style={{ width: "20%" }}>Group Name</th> */}
                <th style={{ width: "20%" }}>Group Name</th>
                <th style={{ width: "25%" }}>Services/Category</th>
                <th style={{ width: "10%" }}>Generated Date</th>
                <th style={{ width: "10%" }}>Generated By</th>
                <th style={{ width: "10%" }}>Amount</th>
                <th style={{ width: "5%" }}></th>
              </tr>
            </thead>
            <tbody style={{ backgroundColor: "white" }}>
              {currentTasks?.map((category, index) => (
                <tr key={index}>
                  <td onClick={() => handleEdit(category)} style={styles.tableLink}>{category?.invoice_id_gen}</td>
                  {/* <td style={styles.tableValue}>
                    {category?.invoice_for === 1 ? <span style={{color:'green'}}> Client /</span>:<span style={{color:'red'}}>Group /</span>} {category?.invoice_type === 1 ? <span > Without Task</span>:<span > With Task</span>}
                  </td> */}
                  <td style={styles.tableValue}>
                    {category?.client_name || '--'}
                    {/* {category?.invoice_for === 1 ? category?.client_name:category?.group_name_client} */}
                  </td>
                  {/* <td style={styles.tableValue}>{category?.group_name || '--'}</td> */}
                  <td style={styles.tableValue}>{category?.group_name_client || '--'}</td>
                  <td style={styles.tableValue}>
                    {category?.service_category_names || '--'}
                    {/* {category?.estimate_type === 1 ? <span style={{color:'green'}}> Service  /</span>:<span style={{color:'red'}}>Task /</span>} {category?.estimate_type === 1 ? category?.service_names:category?.group_name} */}

                  </td>
                  <td style={styles.tableValue}>{convertGMTToLocal(category?.invoice_date, 'dd/MM/yyyy')}</td>
                  <td style={styles.tableValue}>{category?.invoice_gen_emp_name || '--'}
                    {printInvoiceError[category?.invoice_id] &&
                      <div style={{ color: 'red', paddingTop: 10 }} >{printInvoiceError[category?.invoice_id]}</div>}
                    {successMesg[category?.invoice_id] &&
                      <div style={{ color: 'green', paddingTop: 10 }} >{successMesg[category?.invoice_id]}</div>}
                  </td>
                  <td style={styles.tableValue}>{category?.invoice_amt_total}</td>
                  <td>
                    <div
                      style={{
                        display: "flex",
                        gap: "2px", // Space between edit and delete buttons
                      }}
                    >

                      {/* Print Button */}
                      {deleteLoading[category?.invoice_id] ? (
                        <span style={{ marginLeft: '5px' }}>
                          <Loader loading={deleteLoading[category?.invoice_id]} color={'var(--primary-loader-color)'} size="small" />
                        </span>
                      ) :
                        <button
                          className="tasksScreen-edit-button"
                          style={{
                            border: "none",
                            background: "transparent",
                            cursor: deleteLoading[category?.invoice_id] ? "not-allowed" : "pointer",
                            opacity: deleteLoading[category?.invoice_id] ? 0.5 : 1,
                          }}
                          disabled={deleteLoading[category?.invoice_id]}
                        >
                          <img
                            src={printIcon}
                            alt="Download"
                            style={{ width: "16px", height: "16px" }}
                            onClick={() => printInvoiceDocument(category?.invoice_id)}
                          />
                        </button>
                      }

                      {/* Edit Button */}
                      {userPermissions?.invoices?.per_name_sub_json?.invoice_edit === 1 &&
                        <button
                          className="tasksScreen-edit-button"
                          style={{
                            border: "none",
                            background: "transparent",
                            cursor: deleteLoading[category?.invoice_id] ? "not-allowed" : "pointer",
                            opacity: deleteLoading[category?.invoice_id] ? 0.5 : 1,
                          }}
                          disabled={deleteLoading[category?.invoice_id]}
                        >
                          <img
                            src={editIcon}
                            alt="Edit"
                            style={{ width: "16px", height: "16px" }}
                            onClick={() => handleEdit(category)}
                          />
                        </button>
                      }

                      {/* Delete Button */}
                      {userPermissions?.invoices?.per_name_sub_json?.invoice_del === 1 &&
                        <button
                          className="tasksScreen-delete-button"
                          style={{
                            border: "none",
                            background: "transparent",
                            cursor: deleteLoading[category?.invoice_id] ? "not-allowed" : "pointer",
                            opacity: deleteLoading[category?.invoice_id] ? 0.5 : 1,
                          }}
                          disabled={deleteLoading[category?.invoice_id]}
                          onClick={() => confirmDeleteInvoice(category)}
                        >
                          <img
                            src={deleteIcon}
                            alt="Delete"
                            style={{ width: "16px", height: "16px" }}
                          />
                        </button>
                      }
                      {/* {deleteLoading[category?.invoice_id] &&
                          <span><Loader loading={deleteLoading[category?.invoice_id]} color={'var(--primary-loader-color)'} size='small' /></span>
                        } */}
                    </div>
                  </td>

                </tr>
              ))}
            </tbody>
          </table>
          {loading && <Loader loading={loading} color={'var(--primary-loader-color)'} />}
          {error && <div className="list-error-msg">{error} </div>}
          {serviceListLoading && <Loader loading={serviceListLoading} color={'var(--primary-loader-color)'} />}
          {serviceListError && <div className="list-error-msg">{serviceListError} </div>}
          {/* <AddUserModal isOpen={isModalOpen} onClose={handleCloseModal}/> */}
        </div>

      </div>
      <DeleteConfirmationModal
        isOpen={isDeleteModalOpen}
        message={`Are you sure you want to delete ${invoiceInfoRef.current?.invoice_id_gen}?`}
        onClose={handleCloseDeleteModal}
        onConfirm={() => {
          handleCloseDeleteModal(); // Close modal
          handleDeleteInvoiceFile(invoiceInfoRef.current); // Perform delete operation
        }}
      />
      <hr className="divider" style={{ marginTop: '20px' }} />
      <div className="table-footer">
        <div className="total-count"></div>
        <div className="pagination">
          <div className="pagination-info">
            {`${currentPage}-${totalPages} of items`}
          </div>
          <button
            className="pagination-button-arrow"
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            <img src={leftArrowIcon} alt="Previous" className="tasksScreen-arrow-left" style={{ width: '17px', height: '17px' }} />
          </button>
          {visiblePages.map((page) => (
            <button
              key={page}
              className={`tasksScreen-pagination-button ${currentPage === page ? "active" : ""}`}
              onClick={() => handlePageChange(page)}
            >
              {page}
            </button>
          ))}
          <button
            className="pagination-button-arrow"
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            <img src={leftArrowIcon} alt="Next" className="tasksScreen-arrow-right" style={{ width: '17px', height: '17px' }} />
          </button>
        </div>
      </div>
    </>

  )

};

const styles = {
  categoryHeader: {
    color: '#1F384C',
    fontSize: 18,
    fontFamily: 'Roboto Slab',
    fontWeight: 500,
    paddingBottom: 20
  },
  tableWrapper: {
    overflowX: "auto", // Horizontal scroll
    whiteSpace: "nowrap", // Prevent table from wrapping on small devices
    // marginBottom:50
  },
  tableValue: {
    colour: '#192A3E',
    fontFamily: 'Roboto',
    fontWeight: 400,
    fontSize: '12px'
  },
  tableLink: {
    fontFamily: 'Roboto',
    fontWeight: 400,
    fontSize: '12px',
    textDecoration: 'underline',
    color: '#5A55D2'
  },
  container: {
    padding: "5px",
    backgroundColor: "#EFF0F4",
    border: "none",
    // borderRadius: "5px",
    border: '1px #EFF0F4 solid'
  },
  filtersHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    // marginBottom: "15px",
  },
  filterButton: {
    backgroundColor: "white",
    color: "var(--button-bg-color)",
    border: "none",
    borderRadius: "5px",
    padding: "5px 8px",
    cursor: "pointer",
    borderRadius: '20px',
    fontSize: '12px',
    fontWeight: '400',
    fontFamily: 'Roboto',
    border: '1px var(--button-bg-color) solid'

  },
  filterIcon: {
    width: '10px',
    height: '10px',
    paddingRight: '5px'
  },

  paginationButtons: {
    display: "flex",
    gap: "5px",
  },
  paginationButton: {
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    borderRadius: "5px",
    padding: "5px 10px",
    cursor: "pointer",
  },
  filtersContainer: {
    // display: "flex",
    flexWrap: "wrap", // Wrap inputs to the next line if needed
    gap: "20px", // Space between inputs
    marginBottom: "15px",
    // justifyContent: "space-between", // Distribute inputs evenly
    border: '1px #EFF0F4 solid',
    padding: '10px'
  },
  buttonsContainer: {
    display: "flex",
    gap: "10px",
    alignItems: "center",
  },
  applyButton: {
    backgroundColor: "var(--button-bg-color)",
    color: "var(--button-text-color)",
    border: "none",
    borderRadius: "5px",
    padding: "8px 15px",
    cursor: "pointer",
  },
  cancelButton: {
    backgroundColor: "transparent",
    border: "1px solid #ccc",
    borderRadius: "5px",
    padding: "8px 15px",
    cursor: "pointer",
  },
  resetButton: {
    backgroundColor: "transparent",
    color: "#555",
    border: "none",
    cursor: "pointer",
  },
  labaleStyle: {
    fontSize: '12px',
    // marginBottom: '5px',
    fontWeight: '400',
    fontFamily: 'Roboto',
    color: 'rgb(52, 60, 68)'
  },
  dropdownList: {
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    backgroundColor: '#fff',
    border: '1px solid #ccc',
    borderRadius: '4px',
    maxHeight: '200px',
    overflowY: 'auto',
    zIndex: 1000,
    padding: 0, // Remove default padding
    margin: 0, // Remove default margin
    listStyleType: 'none', // Remove the dots
  },
  dropdownItem: {
    padding: '10px',
    cursor: 'pointer',
    borderBottom: '1px solid #eee', // Default for all items
    backgroundColor: '#fff',
    hover: {
      backgroundColor: '#f0f0f0',
    },
  },
}

export default InvoiceBillScreen;